import JobTitleList from './Request/JobTitle_list';

const mapJobTitleList = jobTitlelist => {
  if (!jobTitlelist) return [];
  return jobTitlelist.map(jobTitle => ({
    id: jobTitle.id,
    name: jobTitle.name,
    department: jobTitle.Department?.name ?? '',
    numberOfEmployees: jobTitle.numberOfEmployees,
    numberOfCourses: jobTitle.numberOfCourses,
    // Booleano, no la etiqueta ya escrita: quien pinta la fila es quien sabe en
    // qué idioma está la pantalla.
    active: Boolean(jobTitle.status),
    departmentId: jobTitle.departmentId,
  }));
};

const fetch = async () => {
  const jobTitles = await JobTitleList({ statusFilter: 'ACTIVE' });
  const jobTitleList = mapJobTitleList(jobTitles);
  return { jobTitleList };
};

export default fetch;
